import * as React from 'react';
export const AXSvg = React.forwardRef(function AXSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#0064AD',
      d: 'M2 2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#FFD300',
      d: 'M16 9.539H8V14H4.923V9.539H0V6.461h4.923V2H8v4.461h8z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#DA0E15',
      d: 'M16 8.616H7.077V14H5.846V8.616H0V7.384h5.846V2h1.231v5.384H16z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#004F8B',
      d: 'M15 9.539V6.461h1v3.078ZM4.923 13H8v1H4.923Zm0-11H8v1H4.923ZM0 6.461h1v3.078H0Z',
      opacity: 0.1,
    }),
  );
});
AXSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var AX = {
  category: 'flag',
  colorable: false,
  name: 'AX',
  svg: AXSvg,
};
